module.exports = __webpack_public_path__ + "img/axle_conf_6.5ac76a5c.jpg";